(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[37663],{

/***/ 29530:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/customerService/faq",
      function () {
        return __webpack_require__(27565);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ columns; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/** @format */ 

var columns = [
    {
        dataField: "id",
        text: "No",
        sort: true,
        align: "center",
        headerAlign: "center",
        formatter: function(cellContent, row, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: index + 1
            });
        },
        style: {
            fontSize: "13px",
            color: "#888",
            minWidth: "60px",
            width: "70px"
        },
        headerStyle: function() {
            return {
                width: "10%"
            };
        }
    },
    {
        dataField: "title",
        text: "제목",
        sort: true,
        align: "start",
        headerAlign: "center",
        style: {
            minWidth: "270px",
            maxWidth: "320px",
            fontSize: "13px",
            color: "#333"
        },
        headerStyle: function() {
            return {
                width: "65%"
            };
        }
    },
    {
        dataField: "createdAt",
        text: "작성일",
        sort: true,
        align: "right",
        headerAlign: "center",
        style: {
            minWidth: "100px",
            width: "200px",
            fontSize: "12px",
            color: "#333",
            lineHeight: "1.7"
        },
        headerStyle: function() {
            return {
                width: "25%"
            };
        }
    }, 
];


/***/ }),

/***/ 43928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_table2_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29802);





// 데이터 리스트
var SearchBar = react_bootstrap_table2_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .Search.SearchBar */ .ol.SearchBar, ClearSearchButton = react_bootstrap_table2_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .Search.ClearSearchButton */ .ol.ClearSearchButton;
function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
var SearchTable = function(param) {
    var props = param.props, size = param.size;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var field = document.getElementById("search-bar-0");
        if (field) {
            field.id = uuidv4();
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "col-12 search-area flex align-items-center justify-center mt-3 mt-xl-0 ".concat(size),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "ti-search pl-3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchBar, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props.searchProps), {
                className: "border-search-box"
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ClearSearchButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props.searchProps), {
                className: "clear-btn-2 mr-3"
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchTable);


/***/ }),

/***/ 27565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_table_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99551);
/* harmony import */ var react_bootstrap_table2_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(814);
/* harmony import */ var react_bootstrap_table2_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29802);
/* harmony import */ var components_search_SearchTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43928);
/* harmony import */ var components_columns_CustomerService_CustomerFaqColumns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20624);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79794);
/** @format */ 





// Table






var Notice = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), datas = ref[0], setDatas = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var collectionRef, tempDatas, collectionValue, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    collectionRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__/* .projectFirestore.collection */ .H.collection("customerService").doc("faq").collection("items");
                    tempDatas = [];
                    return [
                        4,
                        collectionRef.orderBy("createdAt", "desc").get()
                    ];
                case 1:
                    collectionValue = _state.sent();
                    collectionValue.forEach(function(doc) {
                        tempDatas.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, doc.data()), {
                            id: doc.id
                        }));
                    });
                    setDatas(tempDatas);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "border-table",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_table2_toolkit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
            keyField: "id",
            bootstrap4: true,
            data: datas,
            columns: components_columns_CustomerService_CustomerFaqColumns__WEBPACK_IMPORTED_MODULE_6__/* .columns */ .z,
            search: true,
            children: function(props) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_search_SearchTable__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                props: props,
                                size: "col-md-12"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_table2_paginator__WEBPACK_IMPORTED_MODULE_3__/* .PaginationProvider */ .bN, {
                            pagination: (0,react_bootstrap_table2_paginator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
                                custom: true,
                                totalSize: datas ? datas.length : 0
                            }),
                            children: function(param) {
                                var paginationProps = param.paginationProps, paginationTableProps = param.paginationTableProps, datas = param.datas;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "p-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_table_next__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                            keyField: "id",
                                            data: datas,
                                            columns: components_columns_CustomerService_CustomerFaqColumns__WEBPACK_IMPORTED_MODULE_6__/* .columns */ .z,
                                            noDataIndication: " "
                                        }, paginationTableProps, props.baseProps), {
                                            wrapperClasses: "table-responsive",
                                            classes: "mytable-hover2 border-table",
                                            rowClasses: "mytable-hover-row2",
                                            expandRow: {
                                                showExpandColumn: true,
                                                expandColumnPosition: "right",
                                                expandHeaderColumnRenderer: function(param) {
                                                    var isAnyExpands = param.isAnyExpands;
                                                    if (isAnyExpands) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            className: "cursor-pointer border py-1 px-2 rounded-full",
                                                            children: "-"
                                                        });
                                                    }
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                        className: "cursor-pointer border py-1 px-2 rounded-full",
                                                        children: "+"
                                                    });
                                                },
                                                expandColumnRenderer: function(param) {
                                                    var expanded = param.expanded;
                                                    if (expanded) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            className: "cursor-pointer bg-red-100 py-1 px-2.5 rounded-full text-danger",
                                                            children: "-"
                                                        });
                                                    }
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                        className: "cursor-pointer bg-blue-100 py-1 px-2 rounded-full text-primary",
                                                        children: "+"
                                                    });
                                                },
                                                renderer: function(datas) {
                                                    return DetailContent((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, datas));
                                                }
                                            }
                                        })),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-between items-center w-full",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_table2_paginator__WEBPACK_IMPORTED_MODULE_3__/* .PaginationListStandalone */ .yJ, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, paginationProps)),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex justify-end",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_table2_paginator__WEBPACK_IMPORTED_MODULE_3__/* .PaginationTotalStandalone */ .NJ, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, paginationProps))
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                });
            }
        })
    });
};
var DetailContent = function(param) {
    var content = param.content, createdAt = param.createdAt;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pb-2 px-14",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-base text-333 leading-5 mb-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-base text-888",
                children: createdAt
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Notice);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [27680,49774,92888,40179], function() { return __webpack_exec__(29530); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);